import { useState } from "react";

const businessModels = [
  {
    title: "Fixed Cost",
    image: "https://assets.thinkwik.com/website/images/business-model/fixed-bid.svg",
    points: [
      "The Fixed-bid model is for projects with predetermined deliverables, accurate budgets and specified timelines.",
      "Compared to other models, it is for projects with high-end budgets and predictable end-to-end solutions offering limited flexibility in project undertaking.",
      "The project development stages and end goals requires minimum attention, management and direction.",
    ],
  },
  {
    title: "Time and material",
    image: "https://assets.thinkwik.com/website/images/business-model/time-and-material.svg",
    points: [
      "Time & material is categorized as a flexible engagement model for projects with undefined requirements, large scope and extended time frames.",
      "With unpredictable use of time & resources, it is an economical option for huge projects that drive for months to years.",
      "This model allows great control to the clients with continuously changing requirements, goals and probabilities.",
    ],
  },
  {
    title: "ODC",
    image: "https://assets.thinkwik.com/website/images/business-model/dedicated-team.svg",
    points: [
      "Expand the in-house IT team by delegating project requirements to ramp up the product development process.",
      "Convenient and cost-effective model to quickly scale the team aligned to your project needs.",
      "Optimal for projects with dynamic scope offering great flexibility, predictable budget and a great degree of control across the development stages.",
    ],
  },
  {
    title: "Hire a Dedicated Developer",
    image: "https://assets.thinkwik.com/website/images/business-model/outstaffing.svg",
    points: [
      "Outstaffing is associated with on-demand team augmentation from developers to team leads and delivery managers leveraging business-specific project needs.",
      "It is quite reasonable in the budget for clients looking for a faster and more effective way to hire talents offshore without worrying about the risk of quality project deliverables.",
      "This model offers complete control to the clients throughout the project commencement and delivers client-centric and favorable solutions.",
    ],
  },
];

export default function BusinessModelsSection() {
  const [activeTab, setActiveTab] = useState(0);
  const [message, setMessage] = useState('');

  const [formData, setFormData] = useState({
    phone: '',
    email: '',
  });

  const validate = () => {
    let newErrors = {};
    if (!formData.phone.trim()) newErrors.phone = 'Phone is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validate();
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setMessage('Message sent successfully!');
      console.log('Form Submitted:', formData);
      setFormData({
        phone: '',
        email: '',
      });
    } else {
      setMessage('');
    }
  };

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10" data-aos="fade-up">
            <h2 className="text-4xl 2xl:text-[40px] lg:text-[32px] font-bold text-[#09588D] font-recoleta">TekIT's Business Models </h2>
          </div>

          {/* Tabs */}
          <div className="max-w-5xl mx-auto mb-8 border-b-1 border-b-gray-900" data-aos="fade-up">
            <div className="flex flex-wrap justify-center gap-2">
              {businessModels.map((model, index) => (
                <button
                  key={index}
                  onClick={() => setActiveTab(index)}
                  className={`px-5 py-2 lg:text-[28px] text-[43px] font-medium font-recoleta border-b-2 transition-all duration-200 ${activeTab === index
                    ? "border-b-[#F86F4B] text-[#F86F4B]"
                    : "border-b-transparent text-[#0A2C4C] hover:text-[#F86F4B]"
                    }`}
                >
                  {model.title}
                </button>
              ))}
            </div>
          </div>

          {/* Content */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-aos="fade-up">
            <div className="flex justify-center">
              <img
                src={businessModels[activeTab].image}
                alt={businessModels[activeTab].title}
                className="max-w-full lg:text-[18px] text-[33px] h-auto"
                loading="lazy"
              />
            </div>
            <div className="px-10">
              <p className="text-[42px] 2xl:text-[26px] lg:text-[20px] font-semibold mb-4 text-[#0A2C4C]">{businessModels[activeTab].title}</p>
              <ul className="space-y-3 list-disc list-inside text-[#0A2C4C]">
                {businessModels[activeTab].points.map((point, i) => (
                  <li key={i} className="font-recoleta text-[42px] 2xl:text-[20px] lg:text-[16px]">
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* <div className="p-4 lg:p-10 lg:px-48 px-10 bg-white font-recoleta">
        <h2 data-aos="fade-up" className="text-[54px] 2xl:text-[40px] lg:text-[32px] text-center font-bold text-[#002856] mb-8 font-recoleta">
          Schedule Call
        </h2>

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div>
              <input
                data-aos="fade-up"
                name="email"
                placeholder="Email *"
                className="w-full border border-gray-300 p-4 rounded placeholder:text-[32px] lg:placeholder:text-[20px]"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <p className="text-red-500 text-[24px] lg:text-sm">{errors.email}</p>}
            </div>

            <div>
              <input
                data-aos="fade-up"
                name="phone"
                placeholder="Phone"
                className="w-full border border-gray-300 p-4 rounded placeholder:text-[32px] lg:placeholder:text-[20px]"
                value={formData.phone}
                onChange={handleChange}
              />
              {errors.phone && <p className="text-red-500 lg:text-sm text-[24px]">{errors.phone}</p>}

            </div>
          </div>

          <div className="justify-center gap-4 mt-6 grid grid-cols-2 px-10  lg:hidden">
            <button
              type="submit"
              className="bg-[#00447b] w-full text-white py-2 px-6 rounded-full hover:bg-[#00325c] duration-300 text-[28px] lg:text-[20px]"
            >
               Submit
            </button>
          </div>
          <div className="justify-center gap-4 mt-6 lg:flex px-10 lg:block hidden">
            <button
              type="submit"
              data-aos="fade-up"
              className="bg-[#00447b] lg:w-52 w-full text-white py-2 px-6 rounded-full hover:bg-[#00325c] duration-300"
            >
              Submit
            </button>
          </div>
        </form>
      </div> */}
    </>
  );
}
